import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { LoginPage } from './features/login/login.page';
import { DashboardPage } from './features/dashboard/dashboard.page';
import { TruckAnnouncementsPage } from './features/truck-announcements/truck-announcements.page';
import { TruckAnnouncementDetailPage } from './features/truck-announcements/truck-announcement-detail.page';
import { TruckAnnouncementFormPage } from './features/truck-announcements/truck-announcement-form.page';
import { TruckAnnouncementPinDetailPage } from './features/truck-announcements/truck-announcement-pin-detail.page';
import { TruckAnnouncementPinEditPage } from './features/truck-announcements/truck-announcement-pin-edit.page';
import { TruckAnnouncementPinsPage } from './features/truck-announcements/truck-announcement-pins.page';
import { VesselAnnouncementsPage } from './features/vessel-announcements/vessel-announcements.page';
import { VesselAnnouncementDetailPage } from './features/vessel-announcements/vessel-announcement-detail.page';
import { WorkOrdersPage } from './features/work-orders/work-orders.page';
import { WorkOrderDetailPage } from './features/work-orders/work-order-detail.page';
import { WorkOrderRowDetailPage } from './features/work-orders/work-order-row-detail.page';
import { ServiceRequestsPage } from './features/service-requests/service-requests.page';
import { ServiceRequestDetailPage } from './features/service-requests/service-request-detail.page';
import { PermitsPage } from './features/permits/permits.page';
import { ContainerUsePage } from './features/container-use/container-use.page';
import { ChangePasswordPage } from './features/user/change-password.page';

export const routes: Routes = [
  { path: 'login', component: LoginPage },
  { path: 'dashboard', component: DashboardPage, canActivate: [authGuard] },

  { path: 'truck-announcements', component: TruckAnnouncementsPage, canActivate: [authGuard] },
  { path: 'truck-announcements/new', component: TruckAnnouncementFormPage, canActivate: [authGuard] },
  { path: 'truck-announcements/:id/edit', component: TruckAnnouncementFormPage, canActivate: [authGuard] },
  { path: 'truck-announcements/:id/pins/:pinId/edit', component: TruckAnnouncementPinEditPage, canActivate: [authGuard] },
  { path: 'truck-announcements/:id/pins/:pinId', component: TruckAnnouncementPinDetailPage, canActivate: [authGuard] },
  { path: 'truck-announcements/:id', component: TruckAnnouncementDetailPage, canActivate: [authGuard] },

  { path: 'truck-announcement-pins', component: TruckAnnouncementPinsPage, canActivate: [authGuard] },
  { path: 'truck-announcement-pins/:pinId/edit', component: TruckAnnouncementPinEditPage, canActivate: [authGuard] },
  { path: 'truck-announcement-pins/:pinId', component: TruckAnnouncementPinDetailPage, canActivate: [authGuard] },

  { path: 'vessel-announcements', component: VesselAnnouncementsPage, canActivate: [authGuard] },
  { path: 'vessel-announcements/:id', component: VesselAnnouncementDetailPage, canActivate: [authGuard] },

  { path: 'work-orders', component: WorkOrdersPage, canActivate: [authGuard] },
  { path: 'work-orders/:id/rows/:rowId', component: WorkOrderRowDetailPage, canActivate: [authGuard] },
  { path: 'work-orders/:id', component: WorkOrderDetailPage, canActivate: [authGuard] },

  { path: 'service-requests', component: ServiceRequestsPage, canActivate: [authGuard] },
  { path: 'service-requests/:id', component: ServiceRequestDetailPage, canActivate: [authGuard] },

  { path: 'permits', component: PermitsPage, canActivate: [authGuard] },
  { path: 'container-use', component: ContainerUsePage, canActivate: [authGuard] },
  { path: 'change-password', component: ChangePasswordPage, canActivate: [authGuard] },

  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  { path: '**', redirectTo: 'dashboard' }
];
